<div class="observation-content full-height">
    <div class="alert alert-warning" role="alert" *ngIf="connectionWarningMessage">
        <img src="assets/img/icons/InfoOutlined.svg" />
        <div>
            <p *ngIf="!isMobile" class="m-0" >{{'ERROR_MESSAGES.MISSING_CONNECTION.LAPTOP' | translate}}
                (<a href="https://play.google.com/store/apps/details?id=com.paulhartmann.bodeHygienePlatform" target="blank" >Android</a>
                {{'ERROR_MESSAGES.MISSING_CONNECTION.AND' | translate}}
                <a href="https://apps.apple.com/de/app/my-hygiene-sop/id1464124118" target="_blank" >Apple</a>)
            </p>
            <p *ngIf="isMobile && isApple" class="m-0">{{'ERROR_MESSAGES.MISSING_CONNECTION.APPLE' | translate}}
                <a href="https://apps.apple.com/de/app/my-hygiene-sop/id1464124118" target="_blank" >Apple</a>
            </p>
            <p *ngIf="isMobile && !isApple" class="m-0" >{{'ERROR_MESSAGES.MISSING_CONNECTION.ANDROID' | translate}}
                <a href="https://play.google.com/store/apps/details?id=com.paulhartmann.bodeHygienePlatform" target="blank" >Android</a>
            </p>
            <div class="d-flex justify-content-between pt-3">
                <a href="https://apps.apple.com/de/app/my-hygiene-sop/id1464124118" target="_blank" *ngIf="showMessageApple"><img src="assets/icons/download-apple.png" /></a>
                <a href="https://play.google.com/store/apps/details?id=com.paulhartmann.bodeHygienePlatform" target="blank" *ngIf="showMessageAndroid"><img src="assets/icons/download-android.png"/></a>
            </div>
        </div>
    </div>
    <!-- <h3 class="section-title mt-4 mb-3">{{ 'OBSERVATION.SELECT.FIELD_OF_ACTIVITY' | translate }}</h3> -->
    <form [formGroup]="formdata" #ngForm="ngForm">
        <!-- <form [formGroup]="formdata" (ngSubmit)="onClickSubmit(formdata.value)" #ngForm="ngForm" > -->
        <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <div class="dropdown dropdown-bhp" style="width: 240px; min-width: 345px;">
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                            <input formControlName="ward" hidden />
                            <input class="dropdown-toggle" type="text" formControlName="wardName" readonly (click)="onClickWardHandler($event)"
                            [ngClass]="{'is-invalid':formdata.get('ward').errors && (formdata.get('ward').touched || formdata.get('ward').dirty || ngForm.submitted)}" />
                            <span class="label-dropdown">{{ translationKeys.Configure.Ward | translate }}*</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
                        </div>
                        <ul class="dropdown-menu">
                            <li [ngValue]="pro" class="dropdown-item" *ngFor="let pro of wards; let i = index" 
                                (click)="onWardIDChange(pro)"
                                [ngClass]=" formdata.get('wardName').value === pro.wardName ? 'active' : ''">  
                                {{ pro.wardName | translate | labelSanitizer }} 
                            </li>
                        </ul>
                    </div>

                    <div class="invalid-feedback" *ngIf="formdata.get('ward').errors && (formdata.get('ward').touched || formdata.get('ward').dirty || ngForm.submitted)">
                        <span *ngIf="formdata.get('ward').errors.required">
                            {{ translationKeys.ErrorMessages.RequiredWard | translate }}
                        </span>
                    </div> 
                </div>
            </div>
            <div class="col-sm-12" *ngIf="wards.length > 0">
                <div class="form-group">
                    <label>{{ translationKeys.Configure.Department | translate }}</label>
                    <!-- <span class="mandatory">*</span> -->
                    <p>{{formdata.get('department').value.departmentName | translate}} {{ getDepartmentTypeName(formdata.get('ward').value) }}</p>
                </div>
            </div>
           
        </div>
        <br>
        <div class="alert alert-warning" role="alert" *ngIf="wardWarningMessage && (userData.roleName.roleId == 5)">
            {{'SOP_OBSERVATION.WARD_NOT_CONFIGURED.CONTACT_INSTITUTION_ADMIN' | translate }}
        </div>
        <div class="alert alert-warning" role="alert" *ngIf="wardWarningMessage && (userData.roleName.roleId == 4)">
            {{'SOP_OBSERVATION.WARD_NOT_CONFIGURED.REFERENCE_CONFIGURE_PAGE' | translate }}
        </div>
        <div class="bd row" *ngIf="!wardWarningMessage">
            <div class="my-2">
                <button type="submit" class="btn-bd-empty continue" (click)="openSopDetails(template,formdata.value)">{{
                    translationKeys.SOPObservation.Continue | translate }}</button>
            </div>
        </div>

    </form>
</div>

<ng-template #template>

</ng-template>